import React from 'react';

import styles from './ListPageLoading.module.scss';

const ListPageLoading: React.FC = ({ ...props }) => (
  <div className={styles.list} {...props}>
    <div className={styles.placeholder}>
      <div className={styles.searchWrapper}>
        <div className={styles.status}> </div>
        <div className={styles.selectRemove}> </div>
        <div className={styles.searchIcon}> </div>
      </div>
      <div className={styles.listItems}>
        <div className={styles.listItem}>
          <div className={styles.logo}> </div>
          <div className={styles.topIdentifier}> </div>
          <div className={styles.bottomIdentifier}> </div>
          <div className={styles.milestone}> </div>
          <div className={styles.expected}> </div>
          <div className={styles.status}> </div>
        </div>
        <div className={styles.listItem}>
          <div className={styles.logo}> </div>
          <div className={styles.topIdentifier}> </div>
          <div className={styles.bottomIdentifier}> </div>
          <div className={styles.milestone}> </div>
          <div className={styles.expected}> </div>
          <div className={styles.status}> </div>
        </div>
      </div>
    </div>
  </div>
);

export default ListPageLoading;
